import Crud from '../views/LandmarkType/Crud'
import Entity from '../views/LandmarkType/Add'

let routes = {
    path: '/landmark_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/landmark_types/add',
            name: 'NewLandmarkType',
            component: Entity,
            meta: {
                pageTitle: 'Landmark Type',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/landmark_types'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/landmark_types/edit/:id?',
            name: 'EditLandmarkType',
            component: Entity,
            meta: {
                pageTitle: 'Landmark Type',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/landmark_types'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/landmark_types',
            name: 'list-landmark_types',
            component: Crud,
            meta: {
                pageTitle: 'Landmark Types',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
